import { Button } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconX } from "@tabler/icons-react";
import React from "react";

const ButtonClose = () => {
  return (
    <Button
      color="red"
      onClick={() => {
        modals.closeAll();
      }}
      leftSection={<IconX size={18} />}
    >
      Đóng
    </Button>
  );
};

export default ButtonClose;
